import style from './style.module.scss';
import {Typography} from 'components/Typography';
import Icon from 'components/Icon';

const ProductOnlineOnlyBanner = () => (
    <div className={style.onlineOnlyMain}>
        <Icon height={18} width={18} icon={'info-new-light-stroke'} className={style.onlineOnlyIcon} />
        <Typography color={'special-blue'} element={'div'} variant={'label-14-r'}>
            Можно заказать только в&nbsp;приложении или на&nbsp;сайте
        </Typography>
    </div>
);

export default ProductOnlineOnlyBanner;
